var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMr = function SvgMr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-72 -28 144 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cd2a3e",
    d: "M-72-28H72v96H-72z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#006233",
    d: "M-72-13.6H72v67.2H-72Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc400",
    d: "M30 2.92c-.08 16.496-13.488 29.84-30 29.84S-29.92 19.416-30 2.92a31 31 0 0 0-1.008 7.84c0 17.12 13.872 31.008 31.008 31.008S31.008 27.896 31.008 10.76A31 31 0 0 0 30 2.92",
    className: "mr_svg__st1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc400",
    d: "M0-9.24-2.694-.949h-8.719l7.053 5.126-2.693 8.291L0 7.344l7.053 5.124L4.36 4.177l7.053-5.125H2.694z"
  })));
};
export default SvgMr;